import React from "react";

// Catches render errors so a single failing component shows a fallback
// instead of unmounting the whole app (blank white page).
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError() {
        return {hasError: true};
    }

    componentDidCatch(error, info) {
        console.error("Unhandled render error:", error, info?.componentStack);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="text-center m-6-auto" style={{marginTop: "40px"}}>
                    <h2>Something went wrong.</h2>
                    <button
                        type="button"
                        className="btn btn-success"
                        style={{marginTop: "16px"}}
                        onClick={() => window.location.reload()}
                    >
                        Reload page
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}
